import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { cutString } from '../../../utils/Generator';
import { getLegalMattersById } from '../../../store/actions/LegalMatterActions';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { connect } from 'react-redux';
import './LegalMatterCard.scss';

const useStyles = makeStyles({
    legalMatterCard: {
        padding: '16px 24px 24px',
        backgroundColor: 'white',
        boxShadow: '0 2px 4px 1px rgba(0, 0, 0, 0.12)',
        borderRadius: 4,
        textTransform: 'inherit',
    },
    legalMatterLabel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
    }
})

const LegalMatterCard = ({
    handleSelectLegalMatter,
    getLegalMattersById,
    legalMatterBody,
    containerStyle,
    onLanding,
    showLoading,
    hideLoading,
}) => {

    const classes = useStyles()

    const handleClick = async () => {
        showLoading()
        const stateOfCountry = localStorage.getItem('stateOfCountry')
        let params = {
            id: legalMatterBody.id
        }
        if (stateOfCountry) {
            params['state'] = stateOfCountry
        }
        try {
            await getLegalMattersById(params)
            handleSelectLegalMatter(
                {
                    category: legalMatterBody ? legalMatterBody.specialty : '',
                    title: legalMatterBody ? legalMatterBody.titleGeneral : ''
                },
                legalMatterBody ? legalMatterBody.id : ''
            )
            hideLoading()
        } catch (error) {
            console.log('error in card', error);
        }
        
    }

    return (
        <Button
            classes={{
                root: classes.legalMatterCard,
                label: classes.legalMatterLabel
            }}
            className={containerStyle && containerStyle}
            onClick={handleClick}
        >
            <h3 className={onLanding? 'LegalMatterCard_title_lg' : 'LegalMatterCard_title'}>
                {legalMatterBody ? cutString(27, legalMatterBody.titleGeneral) : ''}
            </h3>
            <span className={onLanding? 'LegalMatterCard_summary_lg' : 'LegalMatterCard_summary'}>
                {legalMatterBody ? cutString(75, legalMatterBody.summary) : ''}
            </span>
            {legalMatterBody && legalMatterBody.urlMainImage ?
                <img
                    className={onLanding ? 'LegalMatterCard_mainImage_lg' : 'LegalMatterCard_mainImage'}
                    src={legalMatterBody.urlMainImage}
                    alt='legalMatterAvatar'
                /> : null
            }
        </Button>
    )
}

const mapDispatchToProps = dispatch => ({
    getLegalMattersById:
        params => dispatch(getLegalMattersById(params)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
})

export default connect(null, mapDispatchToProps)(LegalMatterCard);
